import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { businessOwnershipApi } from '@store/rtk/businessOwnership';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type BusinessOwnershipType = {
  businessOwnershipTableData: TableData;
};

const { businessOwnershipColumns } = TABLE_COLUMNS;

const initialState: BusinessOwnershipType = {
  businessOwnershipTableData: {
    columns: businessOwnershipColumns,
    rows: [],
    size: 5,
  },
};

export const businessOwnershipSlice = createSlice({
  name: 'businessOwnership',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      businessOwnershipApi.endpoints.getBusinessOwnershipTableData
        .matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.businessOwnershipTableData = {
            ...state.businessOwnershipTableData,
            rows: payload.content,
            last: payload.last,
            page: payload.page,
            size: payload.size,
            totalElements: payload.totalElements,
            totalPages: payload.totalPages,
            filter: payload.filter,
            table: payload.table,
            requestTablePageChange:
              businessOwnershipApi.endpoints.getBusinessOwnershipTableData,
          };
        }
      }
    );
  },
});

export const selectBusinessOwnership = (state: {
  businessOwnership: BusinessOwnershipType;
}) => state.businessOwnership;
export const businessOwnershipReducer = businessOwnershipSlice.reducer;
